const clients = [
  {
    buyerLogo: "Qaser.jpeg",
    companyLogo: "palstine.png",
    buyerName: "Qaser 1",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الضفة الغربية",
  },
  {
    buyerLogo: "funpoint.jpeg",
    companyLogo: "ksa_flag.png",
    buyerName: "Fun Point",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "تبوك",
  },
  {
    buyerLogo: "Alhayat.png",
    companyLogo: "irag_flag.png",
    buyerName: "Alhayat Optics",
    programName: "برنامج ادارة محلات البصريات",
    city: "بغداد",
  },
  {
    buyerLogo: "hithamStore.jpeg",
    companyLogo: "libia_flag.png",
    buyerName: "Hitham Store",
    programName: "برنامج إدارة متاجر بيع الكروت الرقمية",
    city: "طرابلس",
  },
  {
    buyerLogo: "Bayomi.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "جيلاتي بيومي",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "Gamer Garage.png",
    companyLogo: "turkey.png",
    buyerName: "Gamer Garage",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "اسطنبول",
  },
  {
    buyerLogo: "r2gaming.jpg",
    companyLogo: "palstine.png",
    buyerName: "R2 Gaming",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "غزة",
  },
  {
    buyerLogo: "Garage.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Garage",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "المحلة",
  },
  {
    buyerLogo: "papyaga.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Baba Yaga",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "دمياط",
  },
  {
    buyerLogo: "eleeven.jpg",
    companyLogo: "egy_flag.png",
    buyerName: "Eleveen",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "riviera.png",
    companyLogo: "egy_flag.png",
    buyerName: "Riviera Cafe",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "asrarEl3od.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "أسرار العود",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "90+.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "90+",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },

  {
    buyerLogo: "lasosta.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Lasosta",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "Mr_Monkey.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Mr.Monkey 1",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "No Control",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "mercato.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Mercato",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "xo.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "XO",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "دمياط",
  },
  {
    buyerLogo: "score.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Score",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الفيوم",
  },
  {
    buyerLogo: "offside.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Offside",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "Mr_Monkey.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Mr.Monkey 2",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "n1.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "N+1",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "Qaser.jpeg",
    companyLogo: "palstine.png",
    buyerName: "Qaser 2",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الضفة الغربية",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "Zambalek",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "5Bab.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "خمسه باب",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "pubg.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "PUBG",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسماعلية",
  },
  {
    buyerLogo: "Derbey.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Derby Café",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "كفر الشيخ",
  },
  {
    buyerLogo: "psArena.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "PS ARENA",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "champollion.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Champollion",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "EL JOKER",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "psArena.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Arena Co-working Space",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "numberOne.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Number One",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "دمياط",
  },
  {
    buyerLogo: "magic.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "El Magic",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الشرقية",
  },
  {
    buyerLogo: "Qaser.jpeg",
    companyLogo: "palstine.png",
    buyerName: "Qaser 3",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الضفة الغربية",
  },
  {
    buyerLogo: "7rooms.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "7 Rooms",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "zeroFat.png",
    companyLogo: "egy_flag.png",
    buyerName: "Zero Fats",
    programName: "برنامج إدارة الكافيهات",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "ATARI",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "المنيا",
  },
  {
    buyerLogo: "na'na'.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "نأنأة",
    programName: "برنامج إدارة الكافيهات",
    city: "الإسكندرية",
  },
  {
    buyerLogo: "checkps.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "PS Check",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "مطروح",
  },
  {
    buyerLogo: "Alhayat.png",
    companyLogo: "irag_flag.png",
    buyerName: "Alhayat Optics",
    programName: "برنامج ادارة فحوصات البصريات",
    city: "بغداد",
  },
  {
    buyerLogo: "fifa.jpg",
    companyLogo: "egy_flag.png",
    buyerName: "FIFA",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "War Zone",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "TORINO",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "ManCave.jpeg",
    companyLogo: "irag_flag.png",
    buyerName: "Man Cave",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "النجف",
  },
  {
    buyerLogo: "Atlantis.png",
    companyLogo: "egy_flag.png",
    buyerName: "ATLANTIS",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الدقهلية",
  },
  {
    buyerLogo: "Belano.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Belano",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "mask.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Mask",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "R2.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "R2",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "pochinki.jpg",
    companyLogo: "egy_flag.png",
    buyerName: "Pochinki",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الدقهلية",
  },
  {
    buyerLogo: "tikitaka.jpg",
    companyLogo: "egy_flag.png",
    buyerName: "TIKI TAKA",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "newcastle.jpg",
    companyLogo: "egy_flag.png",
    buyerName: "Newcastle",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الجيزة",
  },
  {
    buyerLogo: "+90.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Plus Nintey 1",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "GamerCity.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Gamer City",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "99room.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "99 Room",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "PF5",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "بورسعيد",
  },
  {
    buyerLogo: "skills.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Skills",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "المنصورة",
  },
  {
    buyerLogo: "spot.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "The Spot",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "GameCenter.png",
    companyLogo: "oman_flag.png",
    buyerName: "Game Center",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "مسقط",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "Fair Play",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "Legacy.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Legacy",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "سوهاج",
  },
  {
    buyerLogo: "assist.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Assist",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "دمياط",
  },
  {
    buyerLogo: "gado.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "GADO",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "codeclinic_logo.png",
    companyLogo: "egy_flag.png",
    buyerName: "Mama Africa",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "R2-ma3adee.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "R2",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "القاهرة",
  },
  {
    buyerLogo: "+90.jpeg",
    companyLogo: "egy_flag.png",
    buyerName: "Plus Nintey 2",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "الاسكندرية",
  },
  {
    buyerLogo: "magicSpace.jpg",
    companyLogo: "egy_flag.png",
    buyerName: "Magic Space",
    programName: "برنامج ادارة محلات البلايستيشن والمطاعم",
    city: "دمياط",
  },
];

export default clients;
